import React, { FC, useMemo, useEffect } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { Input, InputGroup } from '@wmgtech/legato'
import { useParams } from 'react-router-dom'

import { useProject } from 'modules/ProjectEdit/serviceHooks'
import { IProjectForm } from '../../types'

export const OwnerField: FC = () => {
  const { id } = useParams<{ id: string }>()
  const {
    field,
    fieldState: { error }
  } = useController<IProjectForm, 'ownerEmail'>({ name: 'ownerEmail' })
  const { setValue, watch } = useFormContext<IProjectForm>()
  const ownerIdValue = watch('ownerId')

  const { getUserById } = useProject(id)

  const validation = useMemo(() => {
    if (error && error?.message) {
      return {
        message: error.message,
        ...(error && { type: 'error' })
      }
    }
    return {}
  }, [error])

  useEffect(() => {
    if (typeof ownerIdValue === 'number') {
      getUserById(ownerIdValue).then(({ email }) => {
        setValue('ownerEmail', email)
      })
    }
  }, [getUserById, ownerIdValue, setValue])

  return (
    <InputGroup label="Project Owner" labelProps={{ icon: 'asterisk' }} validation={validation}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      { /** @ts-ignore * */ }
      <Input {...field} />
    </InputGroup>
  )
}
